import { combineReducers } from 'redux';
import messageLogReducer from './messageLogReducer';
import authenticationReducer from './authenticationReducer';

export default combineReducers({
  messageLogReducer,
  authenticationReducer
});
